import { connect } from 'react-redux';
import TimeoutModal from './TimeoutModal';

const mapStateToProps = ({ purchase, search }) => {
  return {
    isExpired: purchase.get('isExpired'),
    searchDepartureDate: search.get('departureDate'),
    searchReturnsDate: search.get('returnDate'),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

const TimeoutModalConnect = connect(mapStateToProps, null, mergeProps)(TimeoutModal);

export default TimeoutModalConnect;
